import { IApiEntitySmpAgTag } from "@smp/api";
import { UiButtonBase } from "@smp/ui";
import { useNavigate } from "react-router-dom";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { customGeneratePath } from "@/utils";

import { useContextPolotnoTemplates } from "../../../../context";
import { useStyles } from "./palette_item.css";

export const PaletteItem = ({
  colorTag,
  backUrl,
}: {
  colorTag: IApiEntitySmpAgTag;
  backUrl: string;
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    actions: { setActiveEntity },
    state: { pathPattern, isRoutingDisabled },
  } = useContextPolotnoTemplates();

  const {
    actions: { updateSelectedTags },
  } = useContextPolotnoTemplates();

  const handleClick = () => {
    if (colorTag.parent !== "color") {
      return;
    }

    updateSelectedTags(colorTag.parent, colorTag.slug);

    setActiveEntity(undefined);

    if (!isRoutingDisabled) {
      navigate(customGeneratePath(pathPattern));
    }
  };

  const hex = colorTag.slug.replace("color_", "#");

  return hex ? (
    <UiButtonBase
      style={{
        background: hex,
      }}
      className={classes.item}
      onClick={handleClick}
      component={!isRoutingDisabled ? HelperAdapterLink : undefined}
      to={!isRoutingDisabled ? backUrl : undefined}
      onMouseDown={(e) => e.preventDefault()}
    />
  ) : null;
};
